import { createAuth } from '@vendys/web-lib';
import { getAuthHost } from 'apis/host';
import {
  clearByLogout,
  getClient,
  getClients,
  getKmsKeyId,
  getLocalStorageAfterLogout,
  getXUserAgent,
  setLocalStorageAfterLogout
} from './storages';

// 풀 리로드는 토스트/모달이 살아남지 못해 AuthProvider가 마운트 시 등록 — 미등록 시 풀 리로드 폴백
let sessionExpiredHandler: (() => void) | null = null;
export const setSessionExpiredHandler = (handler: (() => void) | null) => {
  sessionExpiredHandler = handler;
};

export const auth = createAuth({
  authURL: getAuthHost() ?? '',
  clientId: getClient() ?? '',
  clientSecret: getClients() ?? '',
  kmsKeyId: getKmsKeyId() ?? '',
  userAgent: () => getXUserAgent(),
  onAuthExpired: () => {
    // 인터셉터 refresh 실패: store-web 부가 키 정리 + 로그인 화면
    const popupDontView = getLocalStorageAfterLogout();
    clearByLogout();
    setLocalStorageAfterLogout(popupDontView);
    if (sessionExpiredHandler) {
      sessionExpiredHandler();
    } else if (typeof window !== 'undefined') {
      window.location.href = '/';
    }
  }
});

export const getToken = (): string | null => auth.getAccessToken();

/**
 * 비-axios 경로(EventSource SSE, window.location 파일 다운로드 등)용 토큰 획득
 */
export const getValidToken = (): Promise<string | null> => auth.getValidAccessToken();
